<template>
    <div class="more-item">
        <p v-html="notification"></p>
    </div>
</template>

<script>
    export default {
        props: {
            notification: String
        }
    }
</script>